// extracted by mini-css-extract-plugin
module.exports = {"integrationcard":"IntegrationCard_integrationcard__sy7py","collapse":"IntegrationCard_collapse__aO_kN"};